import { useCallback, useEffect, useRef, useState } from "react";
import { TTableHeader } from "types/Components/Common/Table/Table";
import { TFilters, UseTableProps } from "types/hooks/useTable";

// @todo remove
export default function useTable ({columns, data, options, ...rest}: UseTableProps) {
    const [headers, setHeaders] = useState<TTableHeader[]>(columns ?? [])
    const [rows, setRows] = useState<any>(data ?? []);
    const [filters, setFilters] = useState<TFilters|undefined>(rest.filters ?? undefined)
    const [headerControlOpen, setHeaderControlOpen] = useState<boolean>(false)

    const defaultHeaders = useRef<TTableHeader[]|null>(null)

    useEffect(() => {
        if(JSON.stringify(rest.filters) !== JSON.stringify(filters)) setFilters(rest.filters ?? undefined)
    }, [rest.filters])

    useEffect(() => {
        let newData = data ?? []

        if(options?.pagination !== "manual") return setRows(newData)

        if(!filters?.page) setRows(newData.slice(0, filters?.limit ?? 100))
        if(options?.pagination === "manual"){
            const start = (((filters?.page ?? 1) - 1) * (filters?.limit as number ?? 100))
            const end = start + (filters?.limit as number ?? 100)
            setRows(newData.slice(start, end))
        }
    }, [data, filters])

    // close header control modal 
    const handleControlClose = useCallback((e: KeyboardEvent) => {
        e.preventDefault()
        if(e.key === "Escape") setHeaderControlOpen(false)
    }, [])

    useEffect(() => {
        if(headerControlOpen) document.addEventListener("keydown", handleControlClose, true)
        else document.removeEventListener("keydown", handleControlClose, true)

        return () => {
            document.removeEventListener("keydown", handleControlClose, true)
        }
    }, [headerControlOpen, handleControlClose])

    /**
     * Initialize all headers with default values for 
     * non-assigned properties
     */
    const initializeHeaders = useCallback(() => {
        if(!columns) return setHeaders([])

        let headerId = 0
        const initailizedHeaders = columns.reduce((acc: TTableHeader[], column) => {
            acc.push({
                id: ++headerId,
                sortable: false,
                display: true,
                options: {
                    sticky: [false, {}],
                    callbackClassNames: undefined,
                    // width: "150px",
                    ...column.options
                },
                ...column,
            })
            return acc
        }, [])
        if (headers === defaultHeaders.current || !headers || !defaultHeaders.current) {
            {
                setHeaders(initailizedHeaders)
                defaultHeaders.current = initailizedHeaders
            }
        }
    }, [columns])

    useEffect(() => {
        // Header initialization with necessary keys
        initializeHeaders()
    }, [columns, initializeHeaders])

    // useEffect(() => {
    //     setFilters({sort: "name", direction: "name"})
    // }, [])

    /**
     * @todo add
     * - pagination
     * - sorting
     * - row selection
     */
    const handleSort = () => {
        
    }

    /**
     * reflect page changes to filters
     * 
     * @param skip - number of rows to skip
     * @param limit - number of rows to return
     */
    const handlePageChange = (page: number) => {
        setFilters((prevFilters) => {
            return {
                ...prevFilters,
                page: page,
            }
        })
    }

    const updateLocalFilters = (value: TFilters) => {
        setFilters(prev => ({...prev, ...value}))
    }

    return {
        headers,
        rows,
        filters,
        defaultHeaders,
        headerControlOpen,
        setHeaders,
        setRows,
        setFilters,
        handleSort,
        handlePageChange,
        setHeaderControlOpen,
        updateLocalFilters,
    }
}